export default "/_next/static/images/stage.76294b9806a8552e0b74f50b398581cf.jpg";